module.exports = __webpack_public_path__ + "static/media/dj.c33fb6a3.svg";